<div
  class="card"
  style="
    margin-bottom: 0px;
    margin-top: 0px;
    font-family: Avenir, Avenir Next, Segoe UI, Helvetica, Arial, sans-serif;
  "
>
  <div class="card-header card-chart card-header-primary">
    <div class="row">
      <div class="col-sm-12 col-md-11">
        <h2 class="card-title text-center"><strong> Crear Grupo </strong></h2>
      </div>
      <div class="col-sm-12 col-md-1">
        <button mat-icon-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="wraper">
      <div class="container">
        <div mat-dialog-content>
          <form [formGroup]="agrupacion">
            <div class="row">
              <div class="col-sm-4 col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Nombre del Grupo </mat-label>
                  <input
                    aria-label="Nombre del Grupo"
                    matInput
                    class="text-center"
                    required
                    formControlName="nombre"
                  />
                  <mat-error
                    *ngIf="
                      agrupacion.controls.nombre.invalid &&
                      (agrupacion.controls.nombre.dirty ||
                        agrupacion.controls.nombre.touched) &&
                      agrupacion.controls.nombre.errors.required
                    "
                  >
                    El campo es requerido.</mat-error
                  >
                </mat-form-field>
              </div>

              <div class="col-sm-4 col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Identificador </mat-label>
                  <input aria-label="Identificador" matInput disabled value="SolserDesarrollo" />
                </mat-form-field>
              </div>
            </div>

            <div class="row" style="margin-top: 10px">
              <div class="col-sm-4 col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Fecha de inicio de uso</mat-label>
                  <input
                    aria-label="Fecha de inicio de uso"
                    matInput
                    [matDatepicker]="picker"
                    formControlName="fecha_alta"
                    (dateInput)="onDateChange($event)"
                    [min]="minDate"
                    [max]="maxDate"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <mat-error
                    *ngIf="
                      agrupacion.controls.fecha_alta.invalid &&
                      (agrupacion.controls.fecha_alta.dirty ||
                        agrupacion.controls.fecha_alta.touched) &&
                      agrupacion.controls.fecha_alta.errors.required
                    "
                  >
                    El campo es requerido.</mat-error
                  >
                </mat-form-field>
              </div>

              <div class="col-sm-4 col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Fecha de fin de uso</mat-label>
                  <input
                    aria-label="Fecha de fin de uso"
                    matInput
                    [matDatepicker]="picker2"
                    formControlName="fecha_vigencia"
                    [min]="minDateVigencia"
                    [max]="maxDateVigencia"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker2"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </form>
        </div>
        <div mat-dialog-actions class="justify-content-end">
          <button
            mat-raised-button
            class="btn btn-link btn-pinterest"
            (click)="clear()"
          >
            <i class="fa fa fa-trash-o"></i> Limpiar
          </button>
          <button
            mat-button
            (click)="save()"
            class="btn btn-success"
            [disabled]="!agrupacion.valid"
          >
            Guardar <i class="material-icons"> save </i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
